<template>
  <div>
    <p>1. 본인은 수령한 보호구를 성실히 착용하겠으며, 보호구 미착용으로 인한 책임은 본인에게 있습니다.</p>
    <p>2. 본인은 수령한 보호구의 분실, 파손(고의적) 등이 발생하지 않도록 관리 책임이 있으며청결하게 보관합니다.</p>

    <!--    기본정보-->
    <field-select-module
      v-model="form.stdInfo"
      :board="this.board"
      :is-print="isPrint"
      :types="['field_name', '부서명_과', 'com_name', 'rank', 'writer_name', 'date', 'updated_at']"
      :typeslabel="{
        date: '최초 작성일',
        updated_at: '최종 수정일',
      }"
      class="mt-8"
    />

    <!-- 보호구 종류별 인증여부 및 인증번호 -->
    <table-custom
      :board="board"
      :is-print="isPrint"
      :title="`<div style='font-weight: 500; margin: 10px 0;'>보호구 종류별 인증여부 및 인증번호
<span style='color: #555555; font-weight: 400;'> *보호구 인증여부 및 인증번호 작성하여 적격품임을 확인하고 지급요함.</span></div>`"
      titleType="circleHtml"
      thema="label"
      :tableData="[
          { id: '종류', title: '종류', type: 'text', placeholder: '내용' },
          { id: '인증여부', title: '인증여부', type: 'radio', radioItems: [{ value: '여' }, { value: '부' }], style: 'min-height: 40px;' },
          { id: '인증번호', title: '인증번호', type: 'customType' },
          { id: '비고', title: '비고', type: 'text', placeholder: '내용' },
        ]"
      v-model="form.보호구종류"
    >
      <template #customType="{ trData }">
        <div v-if="trData && trData.인증여부 && trData.인증여부 === '여'">
          <span v-if="isPrint" class="print-input">{{ trData.인증번호? trData.인증번호 : '' }}</span>
          <ml-input v-else v-model="trData.인증번호" :is-print="isPrint" :readonly="board.readonly" class="w-full" />
        </div>
        <div v-else>
          <span v-if="isPrint" class="print-input" />
        </div>
      </template>
    </table-custom>

    <!-- 개인보호구 지급 대장 -->
    <div class="mt-28px">
      <div class="flex items-center justify-between">
        <h5><i class="dot"></i> 개인보호구 지급 대장</h5>
        <div v-if="!board.readonly && !isPrint" class="flex items-center gap-2">
          <vs-button color="secondary" @click="addCol"> 열 추가 </vs-button>
          <vs-button color="secondary" type="border" @click="deleteCol" :disabled="checkLastCol"> 마지막 열 삭제 </vs-button>
          <vs-button color="secondary" @click="addRow"> 행 추가 </vs-button>
          <vs-button color="secondary" type="border" @click="deleteRow" :disabled="checkedSelectedItem"> 선택삭제 </vs-button>
        </div>
      </div>

      <table class="mt-4">
        <colgroup>
          <col v-if="!board.readonly && !isPrint" width="50" />
          <col v-for="(col, index) in form.보호구지급대장키.filter(item => item.key !== '서명')" :key="`대장키_${index}`" />
          <col v-for="(col, index) in form.보호구지급대장추가키" :key="`대장추가키_${index}`" />
          <col width="240" />
        </colgroup>

        <thead>
        <tr>
          <th v-if="!board.readonly && !isPrint">
            <div class="flex justify-center items-center w-full">
              <vs-checkbox v-model="allCheck" @click.native="onClickAllCheckBox" />
            </div>
          </th>
          <!-- 대장키 -->
          <th v-for="(item, index) in form.보호구지급대장키.filter(item => item.key !== '서명')" :key="`보호구키_${index}`">
            <div>{{ item.label }}</div>
          </th>
          <!-- 추가키 -->
          <th v-for="(item, index) in form.보호구지급대장추가키" :key="`보호구추가키_${index}`">
            <span v-if="isPrint">{{ item.label }}</span>
            <ml-input v-else v-model="item.label" :readonly="board.readonly" class="w-full" />
          </th>
          <th>서명</th>
        </tr>
        </thead>

        <tbody>
        <tr v-for="(row, index) in form.보호구지급대장" :key="`보호구_${index}`">
          <td v-if="!board.readonly && !isPrint">
            <vs-checkbox v-model="row.selected" />
          </td>
          <!-- 대장키 -->
          <td v-for="(col, colIndex) in form.보호구지급대장키.filter(item => item.key !== '서명')" :key="`td1_${colIndex}`">
            <span v-if="isPrint">{{ row[col.key] }}</span>
            <div v-else>
              <date-selector v-if="col.key === '날짜'" v-model="row[col.key]" :readonly="board.readonly" />
              <ml-input v-else-if="col.key === '성명'" v-model="row[col.key]" :readonly="board.readonly" class="w-full" />
              <ml-input v-else v-model="row[col.key]" :readonly="board.readonly" type="number" class="w-full" />
            </div>
          </td>
          <!-- 추가키 -->
          <td v-for="(col, colIndex) in form.보호구지급대장추가키" :key="`td2_${colIndex}`">
            <span v-if="isPrint">{{ row[col.key] }}</span>
            <ml-input v-else v-model="row[col.key]" :readonly="board.readonly" class="w-full" />
          </td>
          <!-- 서명 -->
          <td>
            <div v-if="isPrint" class="w-full flex-1 p-1">
              <img v-if="row.서명" :src="row.서명" width="100%" alt="Signature" class="signatureImg" />
              <div v-else class="signatureImg"></div>
            </div>
            <sign-field v-else v-model="row.서명" :readonly="board.readonly" />
          </td>
        </tr>
        </tbody>
      </table>
    </div>

    <!-- 확인자 -->
    <div>
      <vs-row class="mt-8 mb-4">
        <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
          <h5><i class="dot"></i> 결재란</h5>
        </vs-col>
      </vs-row>
      <name-with-signature-row label-name="담당" :name.sync="form.sign1.name" :signature.sync="form.sign1.sign" />
      <name-with-signature-row label-name="팀장" :name.sync="form.sign2.name" :signature.sync="form.sign2.sign" />
      <name-with-signature-row label-name="과장" :name.sync="form.sign3.name" :signature.sync="form.sign3.sign" />
    </div>

    <!--    파일첨부-->
    <file-upload-module id="fileList" class="w-full mt-4" title="파일첨부" v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly"></file-upload-module>
  </div>
</template>

<script>
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import PhotoUploadGridModule from "@/views/modules/PhotoUploadGridModule";
import FileUploadModule from "@/views/modules/FileUploadModule";
import TableInspect from "@/components/TableInspect";
import SignField from "@/components/SignField.vue";
import DateSelector from "@/components/selector/DateSelector.vue";
import DisasterClassSelector from "@/components/selector/DisasterClassSelector.vue";
import TableInspectMerge from "@/components/TableInspectMerge.vue";
import PrintCheckbox from "@/components/print/PrintCheckbox.vue";
import TableCustom from "@/components/TableCustom.vue";
import CompanySelector from "@/components/selector/CompanySelector.vue";
import NameWithSignatureRow from "@/components/NameWithSignatureRow.vue";

export default {
  components: {
    NameWithSignatureRow,
    CompanySelector,
    TableCustom,
    PrintCheckbox,
    TableInspectMerge,
    DisasterClassSelector,
    DateSelector,
    SignField,
    FileUploadModule,
    TableInspect,
    FieldSelectModule,
    PhotoUploadGridModule,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
    header: Object,
  },
  data() {
    return {
      allCheck: false,
      form: {
        stdInfo: {},
        fileList: [],
        보호구종류: [
          { "id": 1, "종류": "안전모", "비고": "", "인증여부": "여", "인증번호": "11-AV2CQ-0010" },
          { "id": 2, "종류": "안전화", "비고": "", "인증여부": "여", "인증번호": "11-AV2CQ-0020" },
          { "id": 3, "종류": "보안경", "비고": "", "인증여부": "여", "인증번호": "11-AV2CQ-0030" },
          { "id": 4, "종류": "보안면", "비고": "", "인증여부": "여", "인증번호": "11-AV2CQ-0040" },
          { "id": 5, "종류": "방진마스크", "비고": "", "인증여부": "여", "인증번호": "11-AV2CQ-0050" },
          { "id": 6, "종류": "작업장갑", "비고": "인증대상 아님", "인증여부": "부", "인증번호": "" },
        ],
        보호구지급대장키: [
          { key: "날짜", label: "날짜" },
          { key: "성명", label: "성명" },
          { key: "안전모", label: "안전모" },
          { key: "안전화", label: "안전화" },
          { key: "보안경", label: "보안경" },
          { key: "방독마스크", label: "방독마스크" },
          { key: "방진마스크", label: "방진마스크" },
          { key: "귀마개", label: "귀마개" },
          { key: "작업장갑", label: "작업장갑" },
          { key: "서명", label: "서명" }
        ],
        보호구지급대장추가키: [
          { key: "noname1", label: "" },
        ],
        보호구지급대장: [],

        sign1: {
          name: "",
          sign: "",
        },
        sign2: {
          name: "",
          sign: "",
        },
        sign3: {
          name: "",
          sign: "",
        },
      },
    };
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },
  methods: {
    addRow() {
      this.form.보호구지급대장.push({ id: Math.random().toString(36).substr(2, 9)});
      this.allCheck = false;
    },
    deleteRow() {
      const selectedRow = this.form.보호구지급대장.filter((row) => row.selected);
      if (selectedRow.length === 0) {
        return;
      }

      this.form.보호구지급대장 = this.form.보호구지급대장.filter((row) => !row.selected);
      this.allCheck = false;
    },
    onClickAllCheckBox() {
      setTimeout(() => {
        if (this.allCheck) {
          this.form.보호구지급대장.forEach((row) => row.selected = true);
        } else {
          this.form.보호구지급대장.forEach((row) => row.selected = false);
        }
      }, 100);
    },

    addCol() {
      this.form.보호구지급대장추가키.push({ key: Math.random().toString(36).substr(2, 9), label: "" });
    },
    deleteCol() {
      if (this.form.보호구지급대장추가키.length > 0) {
        this.form.보호구지급대장추가키.pop();
      }
    },
  },
  computed: {
    checkedSelectedItem() {
      return this.form.보호구지급대장.filter((row) => row.selected).length === 0;
    },
    checkLastCol() {
      return this.form.보호구지급대장추가키.length <= 0;
    },
  }
};
</script>

<style scoped lang="scss">
$border: 1px solid #cdcdcd;
table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;

  thead {
    th {
      text-align: center;
      font-size: 14px;
      font-weight: 500;
      line-height: 17px;

      background: #f9f9f9;
      border: solid #cdcdcd 1px;
      padding: 6px;
    }
  }
  tbody {
    tr {
      td {
        font-size: 14px;
        font-weight: 500;
        line-height: 17px;
        padding: 5px;
        border: solid #cdcdcd 1px;

        div {
          align-items: center;
        }
      }
    }
  }
}
</style>
